<template>
  <section class="active-ingredients-section ws-grid">
    <div
      class="active-ingredients-section__photo active-ingredient-photo ws-col-8-gte960 ws-col-5-gte1200"
    >
      <responsive-image
        class="active-ingredient-photo__image"
        :name="imageName"
        :image-height-to-width-ratio="$options.imageHeightToWidthRatio"
      />

      <span class="active-ingredient-photo__caption">{{ photoCaption }}</span>
    </div>

    <div
      class="active-ingredients-section__details active-ingredient-details  ws-col-8-gte960 ws-col-5-gte1200 ws-col-4-gte1440"
    >
      <h2 class="active-ingredient-details__small-title u-typography-helvetica u-text u-text--m">
        {{ $t(smallTitle) }}
      </h2>
      <h3
        class="active-ingredient-details__big-title u-typography-helvetica u-text-display u-text-display--s"
      >
        {{ $t(bigTitle) }}
      </h3>

      <p
        v-if="introText"
        class="active-ingredient-details__intro-text u-typography-helvetica u-text u-text--xs"
      >
        {{ $t(introText) }}
      </p>

      <swiper-type-six v-if="hasMultipleIngredients" :key="productName" :items="ingredients">
        <template #item="{ item }">
          <constant-ingredient-info
            :title="item.title"
            :description-paragraphs="item.descriptionParagraphs"
            :concentration="item.concentration"
          />
        </template>
      </swiper-type-six>

      <constant-ingredient-info
        v-else
        :title="ingredients[0].title"
        :description-paragraphs="ingredients[0].descriptionParagraphs"
        :concentration="ingredients[0].concentration"
      />

      <div
        v-if="!isSerum"
        class="active-ingredient-details__see-inci-list"
        @click="onSeeInciListClick"
      >
        {{ $t('discover.expandableList.section.seeInciList') }}
      </div>
    </div>

    <sidebar-popup ref="incilistPopup">
      <product-inci-list :product-name="productName" />
    </sidebar-popup>
  </section>
</template>

<script>
/* eslint-disable */
// eslint-disable import/no-unresolved 
// eslint-disable-next-line import/no-unresolved
import ConstantIngredientInfo from '@/components/product-subpages/ConstantIngredientInfo.vue';
// eslint-disable-next-line import/no-unresolved
import SwiperTypeSix from '@/components/common/app-swiper/SwiperTypeSix.vue';
// eslint-disable-next-line import/no-unresolved
import ResponsiveImage from '@/components/common/ResponsiveImage.vue';
// eslint-disable-next-line import/no-unresolved
import SidebarPopup from '@/components/common/SidebarPopup.vue';
// eslint-disable-next-line import/no-unresolved
import ProductInciList from '@/components/ProductInciList.vue';


// eslint-disable-next-line import/extensions
import { PRODUCT_NAMES } from '@/constants/treatment';

const CONSTANT_ACTIVE_INGREDIENTS_LIST = {
  [PRODUCT_NAMES.NEXULTRA_O]: [
    {
      title: 'constantActiveIngredient.nexUltraO.firstIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltraO.firstIngredient.description.p0',
        'constantActiveIngredient.nexUltraO.firstIngredient.description.p1'
      ],
      concentration: '64'
    },
    {
      title: 'constantActiveIngredient.nexUltraO.secondIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltraO.secondIngredient.description.p0',
        'constantActiveIngredient.nexUltraO.secondIngredient.description.p1'
      ]
    },
    {
      title: 'constantActiveIngredient.nexUltraO.thirdIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltraO.thirdIngredient.description.p0',
        'constantActiveIngredient.nexUltraO.thirdIngredient.description.p1'
      ],
      concentration: '5'
    },
    {
      title: 'constantActiveIngredient.nexUltraO.fourthIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltraO.fourthIngredient.description.p0',
        'constantActiveIngredient.nexUltraO.fourthIngredient.description.p1'
      ],
      concentration: '0.3'
    }
  ],
  [PRODUCT_NAMES.UNIVERSKIN_M]: [
    {
      title: 'constantActiveIngredient.universkinM.firstIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.universkinM.firstIngredient.description.p0',
        'constantActiveIngredient.universkinM.firstIngredient.description.p1'
      ]
    },
    {
      title: 'constantActiveIngredient.universkinM.secondIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.universkinM.secondIngredient.description.p0',
        'constantActiveIngredient.universkinM.secondIngredient.description.p1'
      ]
    },
    {
      title: 'constantActiveIngredient.universkinM.thirdIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.universkinM.thirdIngredient.description.p0',
        'constantActiveIngredient.universkinM.thirdIngredient.description.p1'
      ]
    }
  ],
  [PRODUCT_NAMES.FACE_SERUM]: [
    {
      title: 'constantActiveIngredient.faceSerum.firstIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.faceSerum.firstIngredient.description.p0',
        'constantActiveIngredient.faceSerum.firstIngredient.description.p1'
      ]
    },
    {
      title: 'constantActiveIngredient.faceSerum.secondIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.faceSerum.secondIngredient.description.p0',
        'constantActiveIngredient.faceSerum.secondIngredient.description.p1'
      ],
      concentration: '10'
    },
    {
      title: 'constantActiveIngredient.faceSerum.thirdIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.faceSerum.thirdIngredient.description.p0',
        'constantActiveIngredient.faceSerum.thirdIngredient.description.p1'
      ],
      concentration: '0.2'
    }
  ],
  [PRODUCT_NAMES.EYE_CONTOUR_SERUM]: [
    {
      title: 'constantActiveIngredient.eyeContourSerum.firstIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.eyeContourSerum.firstIngredient.description.p0',
        'constantActiveIngredient.eyeContourSerum.firstIngredient.description.p1'
      ]
    },
    {
      title: 'constantActiveIngredient.eyeContourSerum.secondIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.eyeContourSerum.secondIngredient.description.p0',
        'constantActiveIngredient.eyeContourSerum.secondIngredient.description.p1'
      ],
      concentration: '10'
    },
    {
      title: 'constantActiveIngredient.eyeContourSerum.thirdIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.eyeContourSerum.thirdIngredient.description.p0',
        'constantActiveIngredient.eyeContourSerum.thirdIngredient.description.p1'
      ],
      concentration: '0.2'
    }
  ],
  [PRODUCT_NAMES.UNIVERSKIN_H]: [
    {
      title: 'constantActiveIngredient.universkinH.firstIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.universkinH.firstIngredient.description.p0',
        'constantActiveIngredient.universkinH.firstIngredient.description.p1'
      ],
      concentration: '1.4'
    },
    {
      title: 'constantActiveIngredient.universkinH.secondIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.universkinH.secondIngredient.description.p0',
        'constantActiveIngredient.universkinH.secondIngredient.description.p1'
      ],
      concentration: '10'
    },
    {
      title: 'constantActiveIngredient.universkinH.thirdIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.universkinH.thirdIngredient.description.p0',
        'constantActiveIngredient.universkinH.thirdIngredient.description.p1'
      ]
    }
  ],
  [PRODUCT_NAMES.NEXULTRA_P_LIGHT]: [
    {
      title: 'constantActiveIngredient.nexUltraPLight.firstIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltraPLight.firstIngredient.description.p0',
        'constantActiveIngredient.nexUltraPLight.firstIngredient.description.p1'
      ],
      concentration: '5'
    },
    {
      title: 'constantActiveIngredient.nexUltraPLight.secondIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltraPLight.secondIngredient.description.p0',
        'constantActiveIngredient.nexUltraPLight.secondIngredient.description.p1'
      ]
    },
    {
      title: 'constantActiveIngredient.nexUltraPLight.thirdIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltraPLight.thirdIngredient.description.p0',
        'constantActiveIngredient.nexUltraPLight.thirdIngredient.description.p1'
      ]
    },
    {
      title: 'constantActiveIngredient.nexUltraPLight.fourthIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltraPLight.fourthIngredient.description.p0',
        'constantActiveIngredient.nexUltraPLight.fourthIngredient.description.p1'
      ]
    }
  ],
  [PRODUCT_NAMES.NEXULTRA_P_RICH]: [
    {
      title: 'constantActiveIngredient.nexUltraPRich.firstIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltraPRich.firstIngredient.description.p0',
        'constantActiveIngredient.nexUltraPRich.firstIngredient.description.p1'
      ],
      concentration: '5'
    },
    {
      title: 'constantActiveIngredient.nexUltraPRich.secondIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltraPRich.secondIngredient.description.p0',
        'constantActiveIngredient.nexUltraPRich.secondIngredient.description.p1'
      ]
    },
    {
      title: 'constantActiveIngredient.nexUltraPRich.thirdIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltraPRich.thirdIngredient.description.p0',
        'constantActiveIngredient.nexUltraPRich.thirdIngredient.description.p1'
      ]
    }
  ],
  [PRODUCT_NAMES.GEL]: [
    {
      title: 'constantActiveIngredient.gel.firstIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.gel.firstIngredient.description.p0',
        'constantActiveIngredient.gel.firstIngredient.description.p1',
        'constantActiveIngredient.gel.firstIngredient.description.p2'
      ],
      concentration: '10'
    },
    {
      title: 'constantActiveIngredient.gel.secondIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.gel.secondIngredient.description.p0',
        'constantActiveIngredient.gel.secondIngredient.description.p1',
        'constantActiveIngredient.gel.secondIngredient.description.p2'
      ],
      concentration: '1.2'
    },
    {
      title: 'constantActiveIngredient.gel.thirdIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.gel.thirdIngredient.description.p0',
        'constantActiveIngredient.gel.thirdIngredient.description.p1',
        'constantActiveIngredient.gel.thirdIngredient.description.p2'
      ],
      concentration: '2'
    }
  ],
  [PRODUCT_NAMES.SUNSCREEN_FLD]: [
    {
      title: 'constantActiveIngredient.sunscreenFluidSpf50.firstIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.sunscreenFluidSpf50.firstIngredient.description.p0',
        'constantActiveIngredient.sunscreenFluidSpf50.firstIngredient.description.p1'
      ],
      concentration: '24'
    },
    {
      title: 'constantActiveIngredient.sunscreenFluidSpf50.secondIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.sunscreenFluidSpf50.secondIngredient.description.p0',
        'constantActiveIngredient.sunscreenFluidSpf50.secondIngredient.description.p1'
      ]
    },
    {
      title: 'constantActiveIngredient.sunscreenFluidSpf50.thirdIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.sunscreenFluidSpf50.thirdIngredient.description.p0',
        'constantActiveIngredient.sunscreenFluidSpf50.thirdIngredient.description.p1'
      ]
    }
  ],
  [PRODUCT_NAMES.NEXULTRA_L]: [
    {
      title: 'constantActiveIngredient.nexUltraL.firstIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltraL.firstIngredient.description.p0',
        'constantActiveIngredient.nexUltraL.firstIngredient.description.p1'
      ],
      concentration: '5'
    },
    {
      title: 'constantActiveIngredient.nexUltraL.secondIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltraL.secondIngredient.description.p0',
        'constantActiveIngredient.nexUltraL.secondIngredient.description.p1',
        'constantActiveIngredient.nexUltraL.secondIngredient.description.p2'
      ]
    },
    {
      title: 'constantActiveIngredient.nexUltraL.thirdIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltraL.thirdIngredient.description.p0',
        'constantActiveIngredient.nexUltraL.thirdIngredient.description.p1',
        'constantActiveIngredient.nexUltraL.thirdIngredient.description.p2'
      ],
      concentration: '12+11'
    }
  ],
  [PRODUCT_NAMES.NEXULTRA_UV]: [
    {
      title: 'constantActiveIngredient.nexUltraUV.firstIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltraUV.firstIngredient.description.p0',
        'constantActiveIngredient.nexUltraUV.firstIngredient.description.p1',
        'constantActiveIngredient.nexUltraUV.firstIngredient.description.p2'
      ],
      concentration: '22'
    },
    {
      title: 'constantActiveIngredient.nexUltraUV.secondIngredient.title',
      descriptionParagraphs: ['constantActiveIngredient.nexUltraUV.secondIngredient.description.p0']
    },
    {
      title: 'constantActiveIngredient.nexUltraUV.thirdIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltraUV.thirdIngredient.description.p0',
        'constantActiveIngredient.nexUltraUV.thirdIngredient.description.p1'
      ]
    }
  ],
  [PRODUCT_NAMES.SUNSCREEN_SPF]: [
    {
      title: 'constantActiveIngredient.sunscreenSPF.firstIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.sunscreenSPF.firstIngredient.description.p0',
        'constantActiveIngredient.sunscreenSPF.firstIngredient.description.p1',
        'constantActiveIngredient.sunscreenSPF.firstIngredient.description.p2'
      ],
      concentration: '24 + 7'
    },
    {
      title: 'constantActiveIngredient.sunscreenSPF.secondIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.sunscreenSPF.secondIngredient.description.p0',
        'constantActiveIngredient.sunscreenSPF.secondIngredient.description.p1'
      ]
    },
    {
      title: 'constantActiveIngredient.sunscreenSPF.thirdIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.sunscreenSPF.thirdIngredient.description.p0',
        'constantActiveIngredient.sunscreenSPF.thirdIngredient.description.p1'
      ]
    }
  ],
  [PRODUCT_NAMES.SUNSCREEN_CRM]: [
    {
      title: 'constantActiveIngredient.sunscreenCRM.firstIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.sunscreenCRM.firstIngredient.description.p0',
        'constantActiveIngredient.sunscreenCRM.firstIngredient.description.p1',
        'constantActiveIngredient.sunscreenCRM.firstIngredient.description.p2'
      ],
      concentration: '24 + 7'
    },
    {
      title: 'constantActiveIngredient.sunscreenCRM.secondIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.sunscreenCRM.secondIngredient.description.p0',
        'constantActiveIngredient.sunscreenCRM.secondIngredient.description.p1'
      ]
    },
    {
      title: 'constantActiveIngredient.sunscreenCRM.thirdIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.sunscreenCRM.thirdIngredient.description.p0',
        'constantActiveIngredient.sunscreenCRM.thirdIngredient.description.p1'
      ]
    }
  ],
  [PRODUCT_NAMES.NEXULTRA_B]: [
    {
      title: 'constantActiveIngredient.nexUltraB.firstIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltraB.firstIngredient.description.p0',
        'constantActiveIngredient.nexUltraB.firstIngredient.description.p1'
      ],
      concentration: '5'
    },
    {
      title: 'constantActiveIngredient.nexUltraB.secondIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltraB.secondIngredient.description.p0',
        'constantActiveIngredient.nexUltraB.secondIngredient.description.p1'
      ]
    },
    {
      title: 'constantActiveIngredient.nexUltraB.thirdIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltraB.thirdIngredient.description.p0',
        'constantActiveIngredient.nexUltraB.thirdIngredient.description.p1'
      ]
    },
    {
      title: 'constantActiveIngredient.nexUltraB.fourthIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltraB.fourthIngredient.description.p0',
        'constantActiveIngredient.nexUltraB.fourthIngredient.description.p1'
      ]
    }
  ],
  [PRODUCT_NAMES.NEXULTRA_1]: [
    {
      title: 'constantActiveIngredient.nexUltra1.firstIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltra1.firstIngredient.description.p0',
        'constantActiveIngredient.nexUltra1.firstIngredient.description.p1'
      ],
      concentration: '5'
    },
    {
      title: 'constantActiveIngredient.nexUltra1.secondIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltra1.secondIngredient.description.p0',
        'constantActiveIngredient.nexUltra1.secondIngredient.description.p1'
      ]
    },
    {
      title: 'constantActiveIngredient.nexUltra1.thirdIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltra1.thirdIngredient.description.p0',
        'constantActiveIngredient.nexUltra1.thirdIngredient.description.p1'
      ]
    },
    {
      title: 'constantActiveIngredient.nexUltra1.fourthIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltra1.fourthIngredient.description.p0',
        'constantActiveIngredient.nexUltra1.fourthIngredient.description.p1'
      ]
    }
  ],
  [PRODUCT_NAMES.NEXULTRA_2]: [
    {
      title: 'constantActiveIngredient.nexUltra2.firstIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltra2.firstIngredient.description.p0',
        'constantActiveIngredient.nexUltra2.firstIngredient.description.p1'
      ],
      concentration: '5'
    },
    {
      title: 'constantActiveIngredient.nexUltra2.secondIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltra2.secondIngredient.description.p0',
        'constantActiveIngredient.nexUltra2.secondIngredient.description.p1',
        'constantActiveIngredient.nexUltra2.secondIngredient.description.p2'
      ]
    },
    {
      title: 'constantActiveIngredient.nexUltra2.thirdIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltra2.thirdIngredient.description.p0',
        'constantActiveIngredient.nexUltra2.thirdIngredient.description.p1'
      ]
    }
  ],
  [PRODUCT_NAMES.NEXULTRA_3]: [
    {
      title: 'constantActiveIngredient.nexUltra3.firstIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltra3.firstIngredient.description.p0',
        'constantActiveIngredient.nexUltra3.firstIngredient.description.p1'
      ]
    },
    {
      title: 'constantActiveIngredient.nexUltra3.secondIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltra3.secondIngredient.description.p0',
        'constantActiveIngredient.nexUltra3.secondIngredient.description.p1',
        'constantActiveIngredient.nexUltra3.secondIngredient.description.p2'
      ]
    },
    {
      title: 'constantActiveIngredient.nexUltra3.thirdIngredient.title',
      descriptionParagraphs: [
        'constantActiveIngredient.nexUltra3.thirdIngredient.description.p0',
        'constantActiveIngredient.nexUltra3.thirdIngredient.description.p1'
      ]
    }
  ]
};

const PRODUCT_IMAGES_MAP = {
  [PRODUCT_NAMES.NEXULTRA_O]: 'subpageNexUltraOImage2',
  [PRODUCT_NAMES.NEXULTRA_P_LIGHT]: 'subpageNexUltraPLight6',
  [PRODUCT_NAMES.NEXULTRA_P_RICH]: 'subpageNexUltraPRich6',
  [PRODUCT_NAMES.NEXULTRA_B]: 'subpageNexUltraBImage2',
  [PRODUCT_NAMES.NEXULTRA_L]: 'subpageNexUltraLImage2',
  [PRODUCT_NAMES.SUNSCREEN_SPF]: 'subpageNexUltraZImage2',
  [PRODUCT_NAMES.SUNSCREEN_CRM]: 'subpageSunscreenCRMImage2',
  [PRODUCT_NAMES.NEXULTRA_UV]: 'subpageNexUltraUV2',
  [PRODUCT_NAMES.GEL]: 'subpageGelImage2',
  [PRODUCT_NAMES.SUNSCREEN_FLD]: 'subpageSunscreenFluidImage2',
  [PRODUCT_NAMES.UNIVERSKIN_H]: 'subpageUniverskinHImage2',
  [PRODUCT_NAMES.NEXULTRA_1]: 'subpageNexUltra1Image2',
  [PRODUCT_NAMES.NEXULTRA_2]: 'subpageNexUltra2Image2',
  [PRODUCT_NAMES.NEXULTRA_3]: 'subpageNexUltra3Image2',
  [PRODUCT_NAMES.FACE_SERUM]: 'subpageFaceSerumPackImage2',
  [PRODUCT_NAMES.EYE_CONTOUR_SERUM]: 'subpageEyeContourSerumImage2',
  [PRODUCT_NAMES.UNIVERSKIN_M]: 'subpageUniverskinMImage4'
};

const IMAGE_HEIGHT_TO_WIDTH_RATIO = 1.456;

export default {
  name: 'ConstantActiveIngredientDetails',
  imageHeightToWidthRatio: IMAGE_HEIGHT_TO_WIDTH_RATIO,
  components: {
    ConstantIngredientInfo,
    SwiperTypeSix,
    ResponsiveImage,
    SidebarPopup,
    ProductInciList
  },
  props: {
    productName: {
      type: String,
      required: true
    }
  },
  computed: {
    isSerum() {
      return [PRODUCT_NAMES.FACE_SERUM, PRODUCT_NAMES.EYE_CONTOUR_SERUM].includes(this.productName);
    },
    smallTitle() {
      return this.isSerum
        ? 'discover.products.mainIngredients.serum.title'
        : 'discover.products.mainIngredients.complementary.title';
    },
    bigTitle() {
      return this.isSerum
        ? 'discover.products.mainIngredients.serum.subtitle'
        : 'discover.products.mainIngredients.complementary.subtitle';
    },
    introText() {
      return this.isSerum ? 'discover.products.mainIngredients.serum.introText' : '';
    },
    ingredients() {
      return CONSTANT_ACTIVE_INGREDIENTS_LIST[this.productName];
    },
    hasMultipleIngredients() {
      return this.ingredients.length > 1;
    },
    imageName() {
      return PRODUCT_IMAGES_MAP[this.productName];
    },
    photoCaption() {
      return this.$t(`discover.products.mainIngredients.${this.productName}.photo.title`);
    }
  },
  methods: {
    onSeeInciListClick() {
      return this.$refs.incilistPopup.open();
    }
  }
};
</script>

<style lang="scss" scoped>
.active-ingredients-section {
  padding: 32px var(--ws-grid-m, 16px);
  display: flex;
  flex-direction: column;
  align-items: center;

  &__photo,
  &__details {
    max-width: calc(min(100%, 508px));
  }

  &__photo {
    margin-bottom: 32px;
  }
}

.active-ingredient-photo {
  &__image::v-deep img {
    width: 100%;
  }

  &__caption {
    font-family: var(--u-font-family-Helvetica);
    font-size: 14px;
    line-height: 18px;
    color: var(--u-color-grey-600);
    margin-top: 16px;
    display: inline-block;
  }
}

.active-ingredient-details {
  &__small-title {
    margin-bottom: 24px;
  }

  &__big-title {
    margin-bottom: 24px;
  }

  &__intro-text {
    margin-bottom: 24px;
  }

  &__see-inci-list {
    margin-top: 24px;
    padding-top: 24px;
    color: var(--u-color-grey-700);
    font-family: var(--u-font-family-Gilroy);
    font-weight: 600;
    font-size: 16px;
    line-height: 32px;
    text-decoration: underline;
    border-top: 1px solid var(--u-color-grey-300);
    cursor: pointer;
  }
}

@media (min-width: 600px) {
  .active-ingredients-section {
    padding-top: 64px;
    padding-bottom: 64px;
  }
}

@media (max-width: 960px) {
  .active-ingredients-section {
    &__photo,
    &__details {
      width: 100%;
    }
  }
}

@media (min-width: 960px) {
  .active-ingredients-section {
    &__photo,
    &__details {
      max-width: unset;
    }

    &__see-inci-list {
      margin-top: 32px;
      padding-top: 32px;
    }
  }
}

@media (min-width: 1200px) {
  .active-ingredients-section {
    flex-direction: row;
    align-items: flex-start;

    &__details {
      margin-inline-start: calc(var(--ws-grid-g) * 2 + var(--ws-grid-col-size));
    }
  }
}

@media (min-width: 1440px) {
  .active-ingredients-section {
    padding-top: 120px;
    padding-bottom: 120px;

    &__details {
      margin-top: 40px;
    }
  }

  .active-ingredient-details {
    &__small-title {
      margin-bottom: 16px;
    }

    &__big-title {
      margin-bottom: 32px;
    }

    &__intro-text {
      margin-bottom: 32px;
    }
  }
}
</style>
